<script>
	import swal from 'sweetalert';
	import { mapState } from 'vuex';

	export default{
		data(){
			return{
				formatos:[],
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Aceptar'
					}
				}
			}
		},
		computed:{
			...mapState(['tiendaSeleccionada','alertas','ejercicioActivo']),
			steps(){
				let auto = `Recuerda que si tu aportación es de compra, adicional al formato de autoservicio, 
				debes escoger el formato de distribución <strong>100013</strong>.`;

				let sams = `Recuerda que si tu aportación es de compra, adicional al formato de club de precios, 
				debes escoger el formato de distribución <strong>10019</strong>.`;
				return [{
					target: '[data-v-step="99"]',
					content: this.tiendaSeleccionada == 'autoservicio' ? auto:sams,
					params: {
						placement: 'right'
					}
				}]
			}
		},
		mounted(){
			window.$('.table-format tr:not(:first-child)').click(function(){
				window.$(this).toggleClass('active');
			});
			window.$('#search-format').on('shown.bs.modal', () => {
				if(this.alertas){
					// this.$tours['searchFormat'].start();
				}
				window.$('html').addClass('not-scroll');
			});
			window.$('#search-format').on('hidden.bs.modal', () => {
				window.$('html').removeClass('not-scroll');
			});
		},
		methods:{
			closeFormat(){
				window.$('#search-format').modal('hide');
			},
			submit(){
				if(this.ejercicioActivo == 'ejercicio-1'){
					let formato = this.formatos.find((fmts) => fmts.tipoubicacion == 100001 && fmts.banner == 100351 && fmts.descripcion == 'SUPERAMA');
					let distribution = this.formatos.find((fmts) => fmts.tipoubicacion == 100013 && fmts.banner == 101051 && fmts.descripcion == 'DISTRIBUTION');

					if(!formato){
						swal({
							title: "¡Atención!",
							text: 'El formato no coincide con el ejercicio.',
							icon: "error",
							button: 'Aceptar'
						}).then(() => {
							this.formatos = this.formatos.filter((fmts) => fmts.banner != 101051);
							window.$('.table-format tr.active').removeClass('active');
						});
					}

					if(!distribution){
						swal({
							title: "¡Atención!",
							text: 'Debes seleccionar el formato de distribución para continuar.',
							icon: "error",
							button: 'Aceptar'
						}).then(() => {
							this.formatos = this.formatos.filter((fmts) => fmts.banner != 100351);
							window.$('.table-format tr.active').removeClass('active');
						});
					}

					if(formato && distribution){
						this.$emit('setFormato',this.formatos);
						this.closeFormat();
					}
				}

				if(this.ejercicioActivo == 'ejercicio-2'){
					let formato = this.formatos.find((fmts) => fmts.tipoubicacion == 100001 && fmts.banner == 100451 && fmts.descripcion == 'BODEGA');
					let distribution = this.formatos.find((fmts) => fmts.tipoubicacion == 100013 && fmts.banner == 101051 && fmts.descripcion == 'DISTRIBUTION');

					if(!formato){
						swal({
							title: "¡Atención!",
							text: 'El formato no coincide con el ejercicio.',
							icon: "error",
							button: 'Aceptar'
						}).then(() => {
							this.formatos = this.formatos.filter((fmts) => fmts.banner != 101051);
							window.$('.table-format tr.active').removeClass('active');
						});
					}

					if(!distribution){
						swal({
							title: "¡Atención!",
							text: 'Debes seleccionar el formato de distribución para continuar.',
							icon: "error",
							button: 'Aceptar'
						}).then(() => {
							this.formatos = this.formatos.filter((fmts) => fmts.banner != 100451);
							window.$('.table-format tr.active').removeClass('active');
						});
					}

					if(formato && distribution){
						this.$emit('setFormato',this.formatos);
						this.closeFormat();
					}
				}

				if(this.ejercicioActivo == 'ejercicio-3' || this.ejercicioActivo == 'ejercicio-4'){
					let formato = this.formatos.find((fmts) => fmts.tipoubicacion == 1000017 && fmts.banner == 100551 && fmts.descripcion == 'SAM´S CLUB');
					let distribution = this.formatos.find((fmts) => fmts.tipoubicacion == 1000019 && fmts.banner == 101051 && fmts.descripcion == 'DISTRIBUTION');

					if(!formato){
						swal({
							title: "¡Atención!",
							text: 'El formato no coincide con el ejercicio.',
							icon: "error",
							button: 'Aceptar'
						}).then(() => {
							this.formatos = this.formatos.filter((fmts) => fmts.banner != 101051);
							window.$('.table-format tr.active').removeClass('active');
						});
					}

					if(!distribution){
						swal({
							title: "¡Atención!",
							text: 'Debes seleccionar el formato de distribución para continuar.',
							icon: "error",
							button: 'Aceptar'
						}).then(() => {
							this.formatos = this.formatos.filter((fmts) => fmts.banner != 100551);
							window.$('.table-format tr.active').removeClass('active');
						});
					}

					if(formato && distribution){
						this.$emit('setFormato',this.formatos);
						this.closeFormat();
					}
				}

				if(this.ejercicioActivo == 'evaluacion-1' || this.ejercicioActivo == 'evaluacion-2'){
					this.$emit('setFormato',this.formatos);
					this.closeFormat();
				}
				
			},
			selectFormato(formato){
				this.formatos.push(formato);
			}
		}
	}
</script>
<template>
	<div>
		<v-tour name="searchFormat" :steps="steps" :options="myOptions"/>
		<div id="search-format" class="modal fade" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content" :style="tiendaSeleccionada == 'autoservicio' ? 'height: 500px':'height: 300px'">
					<div class="header-modal">
						<label>Búsqueda: Formato</label>
						<div class="modal-header-buttons">
							<button type="button">
								<i class="far fa-window-maximize"></i>	
							</button>
							<button type="button" data-dismiss="modal">
								<i class="fas fa-times"></i>	
							</button>
						</div>
					</div>
					<div class="body-modal pb-30">
						<table v-if="tiendaSeleccionada == 'autoservicio'" class="table-format table-first-gray table-row-hover">
							<tr>
								<td></td>
								<td>Tipo Ubicación</td>
								<td>Cod. Banner</td>
								<td>Descripción</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100001,banner:100301 ,descripcion:'WM SUPERCENTER'})">
								<td></td>
								<td>100001</td>
								<td>100301</td>
								<td>WM SUPERCENTER</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100001,banner: 100351,descripcion: 'SUPERAMA'})">
								<td></td>
								<td>100001</td>
								<td>100351</td>
								<td>SUPERAMA</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion:100001 ,banner:100401 ,descripcion:'MI BODEGA' })">
								<td></td>
								<td>100001</td>
								<td>100401</td>
								<td>MI BODEGA</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100001,banner:100451 ,descripcion: 'BODEGA'})">
								<td></td>
								<td>100001</td>
								<td>100451</td>
								<td>BODEGA</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100001,banner: 100651,descripcion: 'BODEGA AURRERA EXPRESS'})">
								<td></td>
								<td>100001</td>
								<td>100651</td>
								<td>BODEGA AURRERA EXPRESS</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100001,banner: 101051,descripcion: 'DISTRIBUTION'})">
								<td></td>
								<td>100001</td>
								<td>101051</td>
								<td>DISTRIBUTION</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100001,banner: 103251,descripcion: 'WALMART.COM'})">
								<td></td>
								<td>100001</td>
								<td>103251</td>
								<td>WALMART.COM</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100002,banner: 101001,descripcion: 'HOME OFFICE'})">
								<td></td>
								<td>100002</td>
								<td>101001</td>
								<td>HOME OFFICE</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100002,banner:101251 ,descripcion: 'OTHER'})">
								<td></td>
								<td>100002</td>
								<td>101251</td>
								<td>OTHER</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100012,banner:100301 ,descripcion: 'WM SUPERCENTER'})">
								<td></td>
								<td>100012</td>
								<td>100301</td>
								<td>WM SUPERCENTER</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion:100012 ,banner:100351 ,descripcion: 'SUPERAMA'})">
								<td></td>
								<td>100012</td>
								<td>100351</td>
								<td>SUPERAMA</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion:100012 ,banner:100401 ,descripcion: 'MI BODEGA'})">
								<td></td>
								<td>100012</td>
								<td>100401</td>
								<td>MI BODEGA</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion:100012 ,banner:100451 ,descripcion: 'BODEGA'})">
								<td></td>
								<td>100012</td>
								<td>100451</td>
								<td>BODEGA</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion:100012 ,banner:100651 ,descripcion: 'BODEGA AURRERA EXPRESS'})">
								<td></td>
								<td>100012</td>
								<td>100651</td>
								<td>BODEGA AURRERA EXPRESS</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion:100012 ,banner:101001 ,descripcion:'HOME OFFICE' })">
								<td></td>
								<td>100012</td>
								<td>101001</td>
								<td>HOME OFFICE</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion:100012 ,banner:101251 ,descripcion: 'OTHER'})">
								<td></td>
								<td>100012</td>
								<td>101251</td>
								<td>OTHER</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100012,banner:103251 ,descripcion: 'WALMART.COM'})">
								<td></td>
								<td>100012</td>
								<td>103251</td>
								<td>WALMART.COM</td>
							</tr>
							<tr data-v-step="99" @click="selectFormato({tipoubicacion: 100013,banner:101051 ,descripcion: 'DISTRIBUTION'})">
								<td></td>
								<td>100013</td>
								<td>101051</td>
								<td>DISTRIBUTION</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100013,banner:101251 ,descripcion: 'OTHER'})">
								<td></td>
								<td>100013</td>
								<td>101251</td>
								<td>OTHER</td>
							</tr>
							<tr @click="selectFormato({tipoubicacion: 100036,banner:101551 ,descripcion: 'ESTACIONAMIENTO'})">
								<td></td>
								<td>100036</td>
								<td>101551</td>
								<td>ESTACIONAMIENTO</td>
							</tr>

						</table>

						<table v-if="tiendaSeleccionada == 'sams'" class="table-format table-first-gray table-row-hover">
							<tr>
								<td></td>
								<td>Tipo Ubicación</td>
								<td>Cod. Banner</td>
								<td>Descripción</td>
							</tr>
							<tr  @click="selectFormato({tipoubicacion: 1000017,banner:100551 ,descripcion:'SAM´S CLUB'})">
								<td></td>
								<td>1000017</td>
								<td>100551</td>
								<td>SAM´S CLUB</td>
							</tr>
							<tr  @click="selectFormato({tipoubicacion: 1000018,banner:101251 ,descripcion:'OTHER'})">
								<td></td>
								<td>1000018</td>
								<td>101251</td>
								<td>OTHER</td>
							</tr>
							<tr  @click="selectFormato({tipoubicacion: 1000018,banner:101001 ,descripcion:'HOME OFFICE'})">
								<td></td>
								<td>1000018</td>
								<td>101001</td>
								<td>HOME OFFICE</td>
							</tr>
							<tr data-v-step="99" @click="selectFormato({tipoubicacion: 1000019,banner:101051 ,descripcion:'DISTRIBUTION'})">
								<td></td>
								<td>1000019</td>
								<td>101051</td>
								<td>DISTRIBUTION</td>
							</tr>
						</table>
					</div>
					<div class="footer-modal buttons no-bg">
						<button @click="submit()">Guardar</button>
						<button @click="closeFormat()">Cancelar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
